import { DATE_PIPE_DEFAULT_TIMEZONE, DatePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { DocumentosService } from 'src/app/pages/services/documentos.service';
import { FiniquitoService } from 'src/app/pages/services/finiquitos/finiquito.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { environment } from 'src/environments/environment';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';

@Component({
  selector: 'app-modal-mostrar',
  templateUrl: './modal-mostrar.component.html',
  styleUrls: ['./modal-mostrar.component.css'],
  providers: [DatePipe]
})
export class ModalMostrarComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';
  @Input() idTrabajador: any;

  displayedColumns = ['id', 'fecha', 'total', 'acciones'];
  dataSource: any;
  finiquitos: any;
  info_documento: any;
  loading: boolean = false;
  loadingData: boolean = false;
  trabajadorNombre: string = '';

  constructor(
    private datePipe: DatePipe,
    private finiquitoService: FiniquitoService,
    private alert: AlertHelper,
    private documentoService: DocumentosService,
    private trabajadoresService: TrabajadoresService
  ) { }

  // 🚀 Inicializa el componente cargando los finiquitos y el nombre del trabajador ✨
  ngOnInit(): void {
    this.TraerFiniquitos();
    this.obtenerNombreTrabajador();
  }

  // 🚀 Obtiene el nombre del trabajador y lo almacena en la variable trabajadorNombre ✨
  obtenerNombreTrabajador(): void {
    this.trabajadoresService.traerTrabajadorPorId(this.idTrabajador).subscribe(
      (res) => {
        this.trabajadorNombre = `${res.data[0].nombres} ${res.data[0].apellidos}`;
      },
      (error) => {
        console.error('Error al obtener los datos del trabajador:', error);
        this.trabajadorNombre = 'Nombre no disponible';
      }
    );
  }

  // 🚀 Descarga un archivo de finiquito y lo abre en una nueva ventana ✨
  Descargar(id: any) {
    this.finiquitoService.traerArchivoFiniquito(id).subscribe((res) => {
      if (res.success) {
        this.info_documento = res.data[0];
        window.open(`${environment.API}/finiquitos/` + res.data[0].ruta);
      } else {
        this.alert.errorAlert("No se encuentran archivos");
      }
    });
  }

  // 🚀 Obtiene los finiquitos del trabajador y los formatea adecuadamente ✨
  TraerFiniquitos() {
    this.loadingData = true;

    this.finiquitoService.traerFiniquitoIdTrabajador(this.idTrabajador).subscribe(
      (res) => {
        this.finiquitos = res.data;
        this.dataSource = this.finiquitos;

        for (let i = 0; i < this.finiquitos.length; i++) {
          this.finiquitos[i].fecha = this.datePipe.transform(this.finiquitos[i].fecha, 'yyyy-MM-dd');
        }

        this.loadingData = false;
      },
      (error) => {
        console.error("Error al cargar finiquitos:", error);
        this.loadingData = false;
      }
    );
  }

  // 🚀 Elimina un finiquito y actualiza la lista ✨
  Borrar(id: number, estado: boolean) {
    if (!confirm('¿Seguro que desea eliminar el finiquito?')) return;

    if (estado) {
      this.documentoService.eliminarDocumento(id, 'FINIQUITO').subscribe(() => {
        this.finiquitoService.eliminarFiniquito(id).subscribe(() => {
          this.alert.success_small('Se eliminó el finiquito');
          this.TraerFiniquitos();
        }, (error) => {
          this.alert.error_small('Hubo un error al eliminar el finiquito.');
          console.error(error);
        });
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el finiquito.');
        console.error(error);
      });
    } else {
      this.finiquitoService.eliminarFiniquito(id).subscribe(() => {
        this.alert.success_small('Se eliminó el finiquito');
        this.TraerFiniquitos();
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el finiquito.');
        console.error(error);
      });
    }
  }
}
